export default "__VITE_ASSET__BPIjjIAc__"